/* ==========================================================================
   Enova - Event Product
   Smooth parallax for the product stage (3 shapes + main product image).
   ========================================================================== */

(function () {
  if (typeof window === 'undefined') return;

  var reduceMotionMQ =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var isMobileMQ =
    window.matchMedia && window.matchMedia('(max-width: 749px)');

  var stages = [];
  var rafId = null;

  function collectStages() {
    stages = [];
    var roots = document.querySelectorAll(
      '.enova-event-product [data-parallax-root]'
    );
    var mobileScale = isMobileMQ && isMobileMQ.matches ? 0.55 : 1;

    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var nodes = root.querySelectorAll('[data-parallax-speed]');
      var items = [];
      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        var speed = parseFloat(el.getAttribute('data-parallax-speed')) || 0;
        var baseTransform = el.classList.contains('enova-event-product__main')
          ? 'translate3d(-50%, calc(-50% + __Y__), 0)'
          : 'translate3d(0, __Y__, 0)';
        items.push({
          el: el,
          speed: speed * mobileScale,
          baseTransform: baseTransform,
          current: 0,
          target: 0,
        });
      }
      stages.push({ root: root, items: items });
    }
  }

  function schedule() {
    if (rafId !== null) return;
    rafId = window.requestAnimationFrame(tick);
  }

  function applyTransform(item) {
    var y = item.current.toFixed(2) + 'px';
    item.el.style.transform = item.baseTransform.replace('__Y__', y);
  }

  function tick() {
    rafId = null;

    if (reduceMotionMQ && reduceMotionMQ.matches) {
      for (var s = 0; s < stages.length; s++) {
        var itemsR = stages[s].items;
        for (var k = 0; k < itemsR.length; k++) {
          itemsR[k].current = 0;
          applyTransform(itemsR[k]);
        }
      }
      return;
    }

    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vhHalf = vh * 0.5;
    var needMore = false;

    for (var i = 0; i < stages.length; i++) {
      var stage = stages[i];
      var rootRect = stage.root.getBoundingClientRect();

      if (rootRect.bottom < -vh || rootRect.top > vh * 2) continue;

      var center = rootRect.top + rootRect.height * 0.5;
      var delta = center - vhHalf;

      var items = stage.items;
      for (var j = 0; j < items.length; j++) {
        var item = items[j];
        item.target = -delta * item.speed;
        var diff = item.target - item.current;
        if (Math.abs(diff) > 0.08) {
          item.current += diff * 0.1;
          needMore = true;
        } else {
          item.current = item.target;
        }
        applyTransform(item);
      }
    }

    if (needMore) schedule();
  }

  function onScroll() {
    schedule();
  }

  function onResize() {
    collectStages();
    schedule();
  }

  function resolveTarget(selector) {
    if (!selector) return 0;
    if (selector === '#top' || selector === 'top') return 0;
    try {
      var el = document.querySelector(selector);
      if (el) return el;
    } catch (_) {}
    return 0;
  }

  function initScrollUp() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-enova-scrollup]');
      if (!link) return;
      event.preventDefault();

      var selector = link.getAttribute('data-scroll-target') || '#top';
      var target = resolveTarget(selector);

      if (window.__enovaLenis && window.__enovaLenis.scrollTo) {
        window.__enovaLenis.scrollTo(target, { offset: 0, duration: 1.4 });
        return;
      }

      var top = 0;
      if (target && target.getBoundingClientRect) {
        top = window.pageYOffset + target.getBoundingClientRect().top;
      }

      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({ top: top, behavior: 'smooth' });
      } else {
        window.scrollTo(0, top);
      }
    });
  }

  function init() {
    collectStages();
    initScrollUp();
    if (!stages.length) return;

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    if (reduceMotionMQ && reduceMotionMQ.addEventListener) {
      reduceMotionMQ.addEventListener('change', schedule);
    }
    if (isMobileMQ && isMobileMQ.addEventListener) {
      isMobileMQ.addEventListener('change', onResize);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (
        event.target &&
        event.target.classList &&
        event.target.classList.contains('enova-event-product-section')
      ) {
        collectStages();
        schedule();
      }
    });

    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
